<template>
  <SidebarLayout>
    <ContractorsPlug v-if="false" />
    <div v-else class="contractors-wrapper">
      <ContractorsHeader @add-new="openAddContractorModal" />
      <ScrollPagination
        ref="scroll"
        v-model="contractorsList"
        class="contractors__scroll-container"
        :url="nextUrl"
      >
        <ContractorsMainTable>
          <ContractorsMainTableHeader />
          <ContractorsMainTableRow
            v-for="(contractor, index) in contractorsList"
            :key="contractor.id"
            :contractor="contractor"
            :index="index"
            @edit-contractor="
              openAddContractorModal({ id: contractor.id, isEdit: true, step: $event })
            "
          />
        </ContractorsMainTable>
      </ScrollPagination>
    </div>
  </SidebarLayout>
</template>

<script>
  import SidebarLayout from '@/layouts/SidebarLayout';
  import ContractorsPlug from '@/components/contractors/ContractorsPlug';
  import ContractorsHeader from '@/components/contractors/ContractorsHeader';
  import ContractorsMainTable from '@/components/contractors/contractors-main-table/ContractorsMainTable';
  import ContractorsMainTableHeader from '@/components/contractors/contractors-main-table/ContractorsMainTableHeader';
  import ContractorsMainTableRow from '@/components/contractors/contractors-main-table/ContractorsMainTableRow';
  import { mapActions, mapState } from 'vuex';
  import AddContractorsModal from '@/containers/contractors/add-contractors-modal/AddContractorsModal';
  import { CONTRACTORS_MODAL_STEPS } from '@/utils/constants/contractors-steps';
  import ScrollPagination from '@/containers/common/ScrollPagination';
  import getOptimalLimit from '@/utils/api/optimal-limit';

  export default {
    name: 'Contractors',
    components: {
      ContractorsMainTableRow,
      ContractorsMainTableHeader,
      ContractorsMainTable,
      ScrollPagination,
      ContractorsHeader,
      ContractorsPlug,
      SidebarLayout,
    },
    data() {
      return {
        contractorsList: [],
      };
    },
    computed: {
      ...mapState('contractors', ['contractors', 'nextUrl']),
    },
    methods: {
      ...mapActions('contractors', [
        'loadContractors',
        'loadContractorWorks',
        'loadContractorInfo',
        'clearContractorInfo',
      ]),
      ...mapActions('modal', ['openModal']),
      async openAddContractorModal({ isEdit, id, step } = {}) {
        this.clearContractorInfo();
        this.openModal({
          component: AddContractorsModal,
          context: {
            isEdit,
            id,
            step: step || CONTRACTORS_MODAL_STEPS.GENERAL,
          },
        });
        if (id) {
          await this.loadContractorInfo(id);
        }
      },
    },
    async mounted() {
      const heightOf4kDisplay = 2160;
      const wrapperHeight = this.$refs?.scroll?.$el?.clientHeight || heightOf4kDisplay;
      const limit = getOptimalLimit(wrapperHeight, 40, 0);
      await this.loadContractors({ limit });
      await this.loadContractorWorks();
    },
    watch: {
      contractors(contractors) {
        this.contractorsList = contractors;
      },
    },
  };
</script>
